import React from 'react';
import SaleWidget from './SaleWidget';
import { FaCreditCard, FaDollarSign, FaBuilding, FaWallet } from 'react-icons/fa';
import lang from './lang';

const Widget = (props) => {
    const { data, language, currency, rate } = props;
    const { total, payment } = lang[language || 'uz'];

    const current = data.reduce((obj, item) => {
        if (item.paymentStatus !== 'canceled') {
            if (currency === 'UZS') {
                if (item.exchange) {
                    obj[item.paymentType] += +item.totalValue;
                    obj.totalPayment += +item.totalValue;
                } else {
                    obj[item.paymentType] += +item.salePriceAfterExchange * rate;
                    obj.totalPayment += +item.salePriceAfterExchange * rate;
                }
            } else {
                if (item.exchange) {
                    obj[item.paymentType] += +item.salePriceAfterExchange
                    obj.totalPayment += +item.salePriceAfterExchange;
                    console.log(obj.totalPayment, +item.salePriceAfterExchange);
                } else {
                    obj[item.paymentType] += +item.totalValue;
                    obj.totalPayment += +item.totalValue;
                }
            }
        }

        return obj
    }, { totalPayment: 0, bank: 0, cash: 0, card: 0 });

    return (
        <div className="row">
            <SaleWidget
                title={total}
                mainIcon={<FaWallet />}
                amount={currency === 'UZS' ? parseInt(current.totalPayment).toLocaleString() : parseFloat(current.totalPayment).toFixed(2)}
            />
            <SaleWidget
                title={payment.cash}
                mainIcon={<FaDollarSign />}
                amount={currency === 'UZS' ? parseInt(current.cash).toLocaleString() : parseFloat(current.cash).toFixed(2)}
            />
            <SaleWidget
                title={payment.card}
                mainIcon={<FaCreditCard />}
                amount={currency === 'UZS' ? parseInt(current.card).toLocaleString() : parseFloat(current.card).toFixed(2)}
            />
            <SaleWidget
                title={payment.bank}
                mainIcon={<FaBuilding />}
                amount={currency === 'UZS' ? parseInt(current.bank).toLocaleString() : parseFloat(current.bank).toFixed(2)}
            />
        </div>

    )
}

export default Widget;